import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {CfgARPaymentProcessorModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {DataSource} from '@angular/cdk/collections';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {PaymentProcessorConfigurationService} from './payment-processor-configuration..service';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {MatTableDataSource} from '@angular/material/table';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import {EnumPaymentProcessorModel} from '../models/enum-payment-processor.model';
import {WorkstationConfigurationModel} from '../../../models/configuration/workstation-configuration.model';
import {CfgArPaymentProcessorDeviceModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor-device.model';
import {ARPaymentProcessorModel} from '../../../models/accountsReceivable/ARPaymentProcessorModel';
import {PaymentProcessorDeviceDialogComponent} from './dialogs/payment-processor-device-dialog/payment-processor-device-dialog.component';
import {PaymentProcessorDeviceListModel} from '../models/payment-processor-device-list.model';
import {ConfigurationService} from '../configuration.service';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  Name: string;
  actions = [TdoTableActionsEnum.DELETE];
  model: CfgARPaymentProcessorModel;

  getActionTooltip(actionName: string): string {
    if (actionName === TdoTableActionsEnum.DELETE) {
      return `Delete ${this.Name}`;
    }
  }
}

export class TableViewDataWorkstation extends TdoTableBaseItemModel implements ITdoTableItemModel {
  WorkStationName: string;
  Description: string;
  actions = [TdoTableActionsEnum.EDIT, TdoTableActionsEnum.DELETE];
  model: PaymentProcessorDeviceListModel;

  getActionTooltip(actionName: string): string {
    if (actionName === TdoTableActionsEnum.DELETE) {
      return `Delete ${this.WorkStationName}`;
    }
    else if (actionName === TdoTableActionsEnum.EDIT) {
      return `Edit ${this.WorkStationName}`;
    }
  }
}

@Component({
  selector: 'app-payment-processor-configuration',
  templateUrl: './payment-processor-configuration.component.html',
  styleUrls: ['./payment-processor-configuration.component.scss']
})
export class PaymentProcessorConfigurationComponent implements OnInit {
  @ViewChild('processorTable') processorTable: TdoTableComponent;
  @ViewChild('workstationTable') workstationTable: TdoTableComponent;

  clientList: TdoClientConfigurationModel[] = [];
  locationList: ClientLocationDataModel[] = [];
  enumProcessors: EnumPaymentProcessorModel[] = [];
  processors: CfgARPaymentProcessorModel[] = [];
  workStations: WorkstationConfigurationModel[] = [];
  processorDevices: PaymentProcessorDeviceListModel[] = [];
  processorDevicesLocation: PaymentProcessorDeviceListModel[] = [];
  processorTypes: ARPaymentProcessorModel[] = [];

  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedEnumProcessor: EnumPaymentProcessorModel;
  selectedProcessor: CfgARPaymentProcessorModel;
  selectedProcessorRevert: CfgARPaymentProcessorModel;
  selectedWorkstation: WorkstationConfigurationModel;
  selectedProcessorDevice: CfgArPaymentProcessorDeviceModel;
  selectedProcessorDeviceRevert: CfgArPaymentProcessorDeviceModel;

  deviceParametersJSON: any; // needs to any type, because we're getting unknown json structure from backend
  connectionParametersJSON: any; // needs to any type, because we're getting unknown json structure from backend

  tableModel: TdoTableModel;
  tableViewData: TableViewData[];
  displayedColumns: string[] = ['Name', 'actions'];
  displayedColumnsLabels: string[] = ['Processor'];
  dataSource: DataSource<TableViewData>;

  tableModelWorkstation: TdoTableModel;
  tableViewDataWorkstation: TableViewDataWorkstation[];
  displayedColumnsWorkstation: string[] = ['WorkStationName', 'Description', 'actions'];
  displayedColumnsLabelsWorkstation: string[] = ['Work Station', 'Description'];
  dataSourceWorkstation: DataSource<TableViewDataWorkstation>;

  isSaved: boolean = false;
  saveDisabled: boolean = true;
  isEditing: boolean = false;
  isLoading: boolean = false;

  enumARProcessorIDWorldPayIframe = '00000205-1000-0000-0000-000000000001';
  enumARProcessorIDSquare = '00000205-1000-0000-0000-000000000002';
  enumARProcessorIDTriPosLane3000 = '00000205-1000-0000-0000-000000000003';
  enumARProcessorIDValPay  = '00000205-1000-0000-0000-000000000004';

  constructor(
    private snackBar: MatSnackBar,
    private globals: Globals,
    private dialogService: DialogService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private paymentProcessorConfigService: PaymentProcessorConfigurationService,
    public configurationService: ConfigurationService,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {

    // get payment processors
    this.paymentProcessorConfigService.getPaymentProcessorTypes().subscribe((types) => {
      this.enumProcessors = types;
    }, err => {
      this.createMessage('Error loading processor types', 'Error');
    });

    // get cfgARPaymentProcessorType
    this.paymentProcessorConfigService.getPaymentProcessorTypeIsDevice().subscribe((types) => {
      this.processorTypes = types;
    }, err => {
      this.createMessage('Error loading processor types', 'Error');
    });

    this.paymentProcessorConfigService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }
      this.onChangeClient(null);
    }, err => {
    });
  }

  onChangeClient(e): void {

    this.paymentProcessorConfigService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.selectedLocation = null;
      this.processors = [];

      if (this.locationList.length > 0) {
        const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (currentLoc) {
          this.selectedLocation = currentLoc;
        } else {
          this.selectedLocation = this.locationList[0];
        }
        this.onChangeLoc('');
      }
      else {
        // no locations returned, clear and disable right side
        this.processors = [];
        this.locationList = [];
        this.selectedProcessor = null;
        this.selectedProcessorRevert = null;
      }
    }, err => {
    });
  }

  async onChangeLoc(e) {

    const promises: any[] = [
      this.paymentProcessorConfigService.getPaymentProcessorList(this.selectedLocation.LOCID.toString()).toPromise(),
      this.paymentProcessorConfigService.getPaymentProcessorDevices(this.selectedLocation.LOCID.toString()).toPromise(),
      this.paymentProcessorConfigService.getWorkstations(this.selectedLocation.LOCID.toString()).toPromise(),
    ];

    const results: any[] = await Promise.all(promises);

    this.processors = results[0];
    this.processorDevicesLocation = results[1];
    this.workStations = results[2];

    if (this.processors.length === 0) {
      // no processors returned
      this.processors = [];
      this.selectedProcessor = null;
      this.selectedProcessorRevert = null;
      this.refreshTableViewData(this.processors);
    }
    else {
      this.refreshTableViewData(this.processors);
      this.processorTable.selectRow(this.processors[0]);
      this.selectedProcessor = this.processors[0];
      this.setProcessorDetails();
      this.isEditing = false;
      this.saveDisabled = true;
    }

    if (this.processorDevices.length === 0) {
      // no devices returned
      this.processorDevices = [];
      this.selectedProcessorDevice = null;
      this.selectedProcessorDeviceRevert = null;
    }

    if (this.workStations.length === 0) {
      // no workstations returned
      this.workStations = [];
      this.selectedWorkstation = null;
    }
  }

  refreshTableViewData(models: CfgARPaymentProcessorModel[]): void {
    this.processors = models;
    this.tableViewData = Array.from(this.processors, (_) => {
      const model = new TableViewData();
      model.Name = _.Name;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'Name', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.Name.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }
  }

  refreshTableViewDataWorkstation(models: PaymentProcessorDeviceListModel[]): void {
    this.processorDevices = models;
    this.tableViewDataWorkstation = Array.from(this.processorDevices, (_) => {
      const model = new TableViewDataWorkstation();
      model.WorkStationName = _.WorkStationName;
      model.Description = _.Description;
      model.model = _;
      return model;
    });

    if (!this.tableModelWorkstation) {
      this.dataSourceWorkstation = new MatTableDataSource(this.tableViewDataWorkstation);
      this.tableModelWorkstation = new TdoTableModel(this.displayedColumnsWorkstation, this.displayedColumnsLabelsWorkstation, this.dataSourceWorkstation, 'WorkStationName', 'asc');
      this.tableModelWorkstation.searchPredicate = (data: TableViewDataWorkstation, filter: string) => {
        if (data.WorkStationName.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSourceWorkstation as MatTableDataSource<TableViewDataWorkstation>).data = this.tableViewDataWorkstation;
      (this.dataSourceWorkstation as MatTableDataSource<TableViewDataWorkstation>)._updateChangeSubscription();
    }
  }

  revertSelectedProcessor() {
    if (this.selectedProcessor && this.selectedProcessorRevert) {
      this.processors.forEach(a => {
        if (this.selectedProcessor.PaymentProcessorId === a.PaymentProcessorId) {
          this.selectedProcessor.PaymentProcessorId = this.selectedProcessorRevert.PaymentProcessorId;
          this.selectedProcessor.enumARProcessorID = this.selectedProcessorRevert.enumARProcessorID;
          this.selectedProcessor.LOCID = this.selectedProcessorRevert.LOCID;
          this.selectedProcessor.Name = this.selectedProcessorRevert.Name;
          this.selectedProcessor.ConnectionParametersJSON = this.selectedProcessorRevert.ConnectionParametersJSON;
          this.selectedProcessor.isLOCdefault = this.selectedProcessorRevert.isLOCdefault;
          this.selectedProcessor.DeviceNumber = this.selectedProcessorRevert.DeviceNumber;
          this.connectionParametersJSON = JSON.parse(this.selectedProcessorRevert.ConnectionParametersJSON);
        }
      });
    }
  }

  revertSelectedProcessorDevice() {
    if (this.selectedProcessorDevice && this.selectedProcessorDeviceRevert) {
      this.processorDevices.forEach(a => {
        if (this.selectedProcessorDevice.PaymentDeviceID === a.PaymentDeviceID) {
          this.selectedProcessorDevice.PaymentDeviceID = this.selectedProcessorDeviceRevert.PaymentDeviceID;
          this.selectedProcessorDevice.enumARProcessorID = this.selectedProcessorDeviceRevert.enumARProcessorID;
          this.selectedProcessorDevice.LOCID = this.selectedProcessorDeviceRevert.LOCID;
          this.selectedProcessorDevice.Description = this.selectedProcessorDeviceRevert.Description;
          this.selectedProcessorDevice.DeviceParametersJSON = this.selectedProcessorDeviceRevert.DeviceParametersJSON;
          this.selectedProcessorDevice.isWSdefault = this.selectedProcessorDeviceRevert.isWSdefault;
          this.selectedProcessorDevice.WorkStationId = this.selectedProcessorDeviceRevert.WorkStationId;
          this.deviceParametersJSON = JSON.parse(this.selectedProcessorDeviceRevert.DeviceParametersJSON);
        }
      });
    }
  }

  onTdoTableItemClick(event: TdoTableEvent): void {
    this.revertSelectedProcessor();

    this.selectedProcessor = (event.value as TableViewData).model;
    this.setProcessorDetails();

    this.isEditing = false;
    this.saveDisabled = true;
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;
  }

  onSave(event, showConfirmation: boolean = true) {

    // save processor
    this.isLoading = true;

    // turn json object back into string
    this.selectedProcessor.ConnectionParametersJSON = JSON.stringify(this.connectionParametersJSON);

    // save changes to db
    this.paymentProcessorConfigService.saveProcessor(this.selectedProcessor).subscribe(saved => {
      if (saved)
      {
        // save successful
        if (showConfirmation) {
          this.createMessage('Processor saved', 'Success');
        }

        // if new processor
        const processor = this.processors.filter(a => a.PaymentProcessorId === saved.PaymentProcessorId);
        if (processor.length === 0)
        {
          this.processors.push(saved);
        }

        this.refreshTableViewData(this.processors);
        this.isSaved = true;
        this.selectedProcessor = saved;
        this.setSelectedProcessorRevert();
        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error saving processor', 'Error');
      this.isLoading = false;
    });

    // reset saved vars
    this.isSaved = false;
  }

  isDevice() {
    const type = this.processorTypes.find(a => a.enumARProcessorID === this.selectedProcessor.enumARProcessorID);
    if (type && type.isDevice) {
      return true;
    }
    else {
      return false;
    }
  }

  onCancel(event) {
    this.saveDisabled = true;
    this.isEditing = false;

    // revert changes
    if (!this.isDevice()) {
      this.revertSelectedProcessor();
    }
    else {
      this.revertSelectedProcessorDevice();
    }
  }

  onNewProcessor(event) {
    // set empty by default
    this.selectedProcessor = new CfgARPaymentProcessorModel();
    this.selectedProcessor.isLOCdefault = false;
    this.selectedProcessor.LOCID = this.selectedLocation.LOCID;
    this.setSelectedProcessorRevert(); // might not want this here, possibly set revert after save

    this.saveDisabled = false;
    this.isEditing = true;
  }

  setProcessorDetails() {

    try {
      if (this.selectedProcessor.ConnectionParametersJSON && this.selectedProcessor.ConnectionParametersJSON !== '') {
        this.connectionParametersJSON = JSON.parse(this.selectedProcessor.ConnectionParametersJSON);
      }

      this.processorDevices = this.processorDevicesLocation.filter(a => a.PaymentProcessorId === this.selectedProcessor.PaymentProcessorId);
      this.refreshTableViewDataWorkstation(this.processorDevices);

      this.setSelectedProcessorRevert();
    }
    catch (e)
    {
      console.log(e);

    }
  }

  setProcessorType(enumARProcessor: string) {
    this.selectedProcessor.enumARProcessorID = enumARProcessor;
    this.selectedEnumProcessor = this.enumProcessors.find(a => a.ValidValueItemId === enumARProcessor);

    // if connection params missing
    // if (!this.selectedProcessor.ConnectionParametersJSON || (this.selectedProcessor.ConnectionParametersJSON && this.selectedProcessor.ConnectionParametersJSON === '')) {
    //   this.selectedProcessor.ConnectionParametersJSON = this.selectedEnumProcessor.ConnectionParametersJSON;
    //   this.connectionParametersJSON = JSON.parse(this.selectedEnumProcessor.ConnectionParametersJSON);
    //   const blah = '';
    // }
    //




    if(!this.selectedProcessor.ConnectionParametersJSON)
    {
      // blank
      switch(this.selectedProcessor.enumARProcessorID)  {
        case this.enumARProcessorIDValPay: {
          this.selectedProcessor.ConnectionParametersJSON =
            '{"Model_SerialNumber":"","Store_ID":"","Merchant_Account":""}';

        }



      }
    }

    try {

      let obj: any =JSON.parse(this.selectedProcessor.ConnectionParametersJSON);
      this.connectionParametersJSON = obj;
    }
    catch (e)
    {
      console.log(e);
    }

    let z =0 ;



  }

  setProcessorDeviceDetails(workStation: WorkstationConfigurationModel) {
    // set empty by default
    this.deviceParametersJSON = JSON.parse(this.selectedEnumProcessor.ConnectionParametersJSON);
    this.selectedProcessorDevice = new CfgArPaymentProcessorDeviceModel();
    this.selectedProcessorDevice.enumARProcessorID = this.selectedEnumProcessor.ValidValueItemId;
    this.selectedProcessorDevice.LOCID = this.selectedLocation.LOCID;
    this.selectedProcessorDevice.WorkStationId = this.selectedWorkstation.WorkStationId; // <=== make sure (WorkStationId) is getting filled
    this.setSelectedProcessorDeviceRevert();

    if (this.processorDevices && this.processorDevices.length > 0)
    {
      const details = this.processorDevices.find(a => a.enumARProcessorID === this.selectedEnumProcessor.ValidValueItemId && a.WorkStationId === this.selectedWorkstation.WorkStationId);

      if (details) {
        this.selectedProcessorDevice = details;
        if (this.selectedProcessorDevice.DeviceParametersJSON && this.selectedProcessorDevice.DeviceParametersJSON !== '') {
          this.deviceParametersJSON = JSON.parse(this.selectedProcessorDevice.DeviceParametersJSON);
        }
        else {
          this.deviceParametersJSON = JSON.parse(this.selectedEnumProcessor.ConnectionParametersJSON);
        }
        this.setSelectedProcessorDeviceRevert();
      }
    }
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  setSelectedProcessorRevert() {
    if (!this.selectedProcessorRevert) {
      this.selectedProcessorRevert = new CfgARPaymentProcessorModel();
    }
    this.selectedProcessorRevert.PaymentProcessorId = this.selectedProcessor.PaymentProcessorId;
    this.selectedProcessorRevert.enumARProcessorID = this.selectedProcessor.enumARProcessorID;
    this.selectedProcessorRevert.LOCID = this.selectedProcessor.LOCID;
    this.selectedProcessorRevert.Name = this.selectedProcessor.Name;
    this.selectedProcessorRevert.ConnectionParametersJSON = this.selectedProcessor.ConnectionParametersJSON;
    this.selectedProcessorRevert.isLOCdefault = this.selectedProcessor.isLOCdefault;
    this.selectedProcessorRevert.DeviceNumber = this.selectedProcessor.DeviceNumber;
  }

  setSelectedProcessorDeviceRevert() {
    if (!this.selectedProcessorDeviceRevert) {
      this.selectedProcessorDeviceRevert = new CfgArPaymentProcessorDeviceModel();
    }
    this.selectedProcessorDeviceRevert.PaymentDeviceID = this.selectedProcessorDevice.PaymentDeviceID;
    this.selectedProcessorDeviceRevert.enumARProcessorID = this.selectedProcessorDevice.enumARProcessorID;
    this.selectedProcessorDeviceRevert.LOCID = this.selectedProcessorDevice.LOCID;
    this.selectedProcessorDeviceRevert.Description = this.selectedProcessorDevice.Description;
    this.selectedProcessorDeviceRevert.DeviceParametersJSON = this.selectedProcessorDevice.DeviceParametersJSON;
    this.selectedProcessorDeviceRevert.isWSdefault = this.selectedProcessorDevice.isWSdefault;
    this.selectedProcessorDeviceRevert.WorkStationId = this.selectedProcessorDevice.WorkStationId;
  }

  changeValue(key, value) {
    this.connectionParametersJSON[key] = value;
    this.selectedProcessorRevert = this.selectedProcessorRevert;
  }

  test() {
    this.selectedProcessorRevert = this.selectedProcessorRevert;
  }

  trackByFn(i: number, items: any) {
    return i; // returning the index itself for avoiding ngFor to change focus after ngModelChange
  }

  showSelectedProcessorJSONParams() {
    if (this.selectedProcessor.enumARProcessorID) {
      if (this.isDevice() && this.selectedProcessor.DeviceNumber) {
        return true;
      }
      else if (!this.isDevice()) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  pairDevice($event) {
    this.isLoading = true;

    // get latest json changes
    this.selectedProcessor.ConnectionParametersJSON = JSON.stringify(this.connectionParametersJSON);

    if (this.selectedProcessor.enumARProcessorID === this.enumARProcessorIDSquare) {
      // pair rectangle health device
      this.createMessage('Error pairing processor - Setup method not yet developed', 'Error');
    }
    // else if (this.selectedProcessor.enumARProcessorID === this.enumARProcessorIDTriPosLane3000) {
    //   this.paymentProcessorConfigService.pairTriPosDevice(this.selectedProcessor).subscribe(pair => {
    //     if (pair)
    //     {
    //       if (pair.IsSuccessful) {
    //         this.createMessage('Processor paired', 'Success');
    //         if (this.connectionParametersJSON) {
    //           if (this.connectionParametersJSON.IsPaired) {
    //             this.connectionParametersJSON.IsPaired = '1';
    //           }
    //         }

    //         // save here
    //         this.onSave(null);
    //       }
    //       else {
    //         this.createMessage('Error pairing processor. Please make sure you are using the current activation code on the screen of the device. These codes can change.', 'Error');
    //       }
    //     }
    //     this.isLoading = false;
    //   }, err => {
    //     this.createMessage('Error pairing processor', 'Error');
    //     this.isLoading = false;
    //   });
    // }
  }

  unPairDevice($event) {
    this.isLoading = true;

    // get latest json changes
    this.selectedProcessor.ConnectionParametersJSON = JSON.stringify(this.connectionParametersJSON);

    // this.paymentProcessorConfigService.unPairTriPosDevice(this.selectedProcessor).subscribe(pair => {
    //   if (pair)
    //   {
    //     if (pair.IsSuccessful) {
    //       this.createMessage('Processor Unpaired', 'Success');
    //       if (this.connectionParametersJSON) {
    //         if (this.connectionParametersJSON.IsPaired) {
    //           this.connectionParametersJSON.IsPaired = '0';
    //         }
    //       }
    //       // save here
    //       this.onSave(null, false);
    //     }
    //     else {
    //       this.createMessage('Error unpairing processor', 'Error');
    //     }
    //   }
    //   this.isLoading = false;
    // }, err => {
    //   this.createMessage('Error unpairing processor', 'Error');
    //   this.isLoading = false;
    // });
  }

  getProcessorPaired($event) {
    // get latest json changes
    this.selectedProcessor.ConnectionParametersJSON = JSON.stringify(this.connectionParametersJSON);

    // this.paymentProcessorConfigService.getTriPosLaneExists(this.selectedProcessor).subscribe(pair => {
    //   if (pair)
    //   {
    //     if (pair.IsSuccessful) {
    //       this.createMessage('Processor Unpaired', 'Success');
    //     }
    //     else {
    //       this.createMessage('Error unpairing processor', 'Error');
    //     }
    //   }
    // }, err => {
    //   this.createMessage('Error unpairing processor', 'Error');
    //   this.isLoading = false;
    // });
  }

  getActivationCode(): string {
    let code = '';
    if (this.connectionParametersJSON) {
      if (this.connectionParametersJSON.ActivationCode) {
          code = this.connectionParametersJSON.ActivationCode;
        }
    }

    return code;
  }

  getDevicePairedStatusText(): string {
    let status = 'No';
    if (this.connectionParametersJSON) {
      if (this.connectionParametersJSON.IsPaired) {
        status = this.connectionParametersJSON.IsPaired;
        if (status === '1') {
          return 'Yes';
        }
        else {
          return 'No';
        }
      }
    }
    return status;
  }

  getDevicePairedStatusBoolean(): boolean {
    if (this.connectionParametersJSON) {
      if (this.connectionParametersJSON.IsPaired) {
        if (this.connectionParametersJSON.IsPaired === '1') {
          return true;
        }
        else {
          return false;
        }
      }
    }
    return false;
  }

  updateActivationCode($event) {
    const code = $event.target.value;
    if (this.connectionParametersJSON.ActivationCode) {
      this.connectionParametersJSON.ActivationCode = code;
    }
  }

  onTdoTableItemWorkstationClick($event: any) {

  }

  openPaymentProcessorDeviceDialog(PaymentDeviceID: string) {
    const dialogRef = this.dialog.open(PaymentProcessorDeviceDialogComponent, {
      width: '700px',
      height: '410px',
      panelClass: 'dialog',
      data: {
        paymentDeviceID: PaymentDeviceID,
        locid: this.selectedLocation.LOCID,
        paymentProcessorID: this.selectedProcessor.PaymentProcessorId,
        paymentProcessorDevices: this.processorDevices
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.paymentProcessorConfigService.getPaymentProcessorDevices(this.selectedLocation.LOCID.toString()).subscribe((devices) => {
        this.processorDevicesLocation = devices;
        this.processorDevices = this.processorDevicesLocation.filter(a => a.PaymentProcessorId === this.selectedProcessor.PaymentProcessorId);
        this.refreshTableViewDataWorkstation(this.processorDevices);
      }, err => {
        this.createMessage('Error loading device workstations', 'Error');
      });
    }, err => {
    });
  }

  onTdoTableItemActionClickWorkstation(event: TdoTableEvent): void {
    if (this.isEditing) {
      const model = (event.value as TableViewDataWorkstation).model;
      switch (event.action) {
        case TdoTableActionsEnum.DELETE:
          this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.WorkStationName}?`).subscribe((result) => {
            if (result === true) {
              // remove payment processor device
              const device = new CfgArPaymentProcessorDeviceModel();
              device.PaymentProcessorId = model.PaymentProcessorId;
              device.PaymentDeviceID = model.PaymentDeviceID;
              device.WorkStationId = model.WorkStationId;
              device.DeviceParametersJSON = model.DeviceParametersJSON;
              device.LOCID = model.LOCID;
              device.isWSdefault = model.isWSdefault;
              device.Description = model.Description;
              device.xauditTableRowID = model.xauditTableRowID;
              device.xauditModifiedOn = model.xauditModifiedOn;
              device.xauditDeleted = true;
              device.xauditModifiedBy = model.xauditModifiedBy;
              device.xauditCreatedOn = model.xauditCreatedOn;
              device.xauditCreatedBy = model.xauditCreatedBy;

              this.paymentProcessorConfigService.saveProcessorDevice(device).subscribe((devices) => {
                this.processorDevicesLocation = this.processorDevicesLocation.filter(a => a.PaymentDeviceID !== model.PaymentDeviceID);
                this.processorDevices = this.processorDevicesLocation.filter(a => a.PaymentProcessorId === this.selectedProcessor.PaymentProcessorId);
                this.refreshTableViewDataWorkstation(this.processorDevices);
              }, err => {
                this.createMessage('Error loading device workstations', 'Error');
              });
            } else {
              //
            }
          });
          break;
        case TdoTableActionsEnum.EDIT:
          this.openPaymentProcessorDeviceDialog(model.PaymentDeviceID);
          break;
      }
    }
    else {
      // block editing
      this.refreshTableViewDataWorkstation(this.processorDevices);
    }
  }

  onTdoTableItemActionClick(event: TdoTableEvent) {
    const model = (event.value as TableViewData).model;
    switch (event.action) {
      case TdoTableActionsEnum.DELETE:
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.Name}?`).subscribe((result) => {
          if (result === true) {
            // remove payment processor
            model.xauditDeleted = true;
            this.paymentProcessorConfigService.saveProcessor(model).subscribe((devices) => {
              this.processors = this.processors.filter(a => a.PaymentProcessorId !== model.PaymentProcessorId);
              this.refreshTableViewData(this.processors);
            }, err => {
              this.createMessage('Error removing payment processor', 'Error');
            });
          } else {
            //
          }
        });
        break;
    }
  }
}
